'use strict';

const form = document.querySelector('.form');
const containerWorkouts = document.querySelector('.workouts');
const inputType = document.querySelector('.form__input--type');
const settingsBtn = document.querySelector('.icon-settings');
const settings = document.querySelector('.settings');
let inputDistance = document.querySelector('.form__input--distance');
let inputDuration = document.querySelector('.form__input--duration');
let inputCadence = document.querySelector('.form__input--cadence');
let inputElevation = document.querySelector('.form__input--elevation');

let deleteWorkout;
let editWorkout;

class Workout {
  date = new Date();

  //normally libraries are used to create IDs ()
  // returns the last 10 numbers of the string
  id = (Date.now() + '').slice(-10);

  constructor(coords, distance, duration) {
    this.coords = coords;
    this.distance = distance; //in km
    this.duration = duration; // in m,n
  }

  // used on child elements because of the "type" variable is present on them
  _setDescription() {
    // prettier-ignore
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    this.description = `${this.type[0].toUpperCase()}${this.type.slice(1)} on ${
      months[this.date.getMonth()]
    } ${this.date.getDate()}`;
  }
}

class Running extends Workout {
  type = 'running';
  constructor(coords, distance, duration, cadence) {
    super(coords, distance, duration);
    this.cadence = cadence;
    this.calcPace();
    this._setDescription();
  }

  calcPace() {
    // min / km
    this.pace = this.duration / this.distance;
    return this.pace;
  }
}

class Cycling extends Workout {
  type = 'cycling';
  constructor(coords, distance, duration, elevationGain) {
    super(coords, distance, duration);
    this.elevationGain = elevationGain;
    this.calcSpeed();
    this._setDescription();
  }
  calcSpeed() {
    // km/h
    this.speed = this.distance / this.duration / 60;
    return this.speed;
  }
}

// const run = new Running([40, 40], 5.2, 24, 178);
// const cycling = new Cycling([40, 40], 24, 95, 523);

// console.log(run, cycling);

////////////////////////////////////
// APPLICATION ARCHITECTURE

class App {
  #map;
  #mapEvent;
  #workouts = [];
  #mapZoomLevel = 13;

  // called immediately when a new object from "App" is created
  constructor() {
    this._getPosition();

    // same way default this value of the event listeners are the DOM elements, thats why .bind(this) must be added
    form.addEventListener('submit', this._newWorkout.bind(this));

    inputType.addEventListener('change', this._toggleElevationField);

    containerWorkouts.addEventListener('click', this._moveToPopup.bind(this));

    settingsBtn.addEventListener('click', this._showSettings.bind(this));

    //get data from localStorage
    this._getLocalStorage();
  }

  _getPosition() {
    if (navigator.geolocation) {
      try {
        // GeoLocation API setting up (getting coordinates)
        navigator.geolocation.getCurrentPosition(
          /*. !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        
        bind(this) sets the this keyword to the object, otherwise it will return undefined (because we dont call _loadMap() ourselves, _getPosition does that as regular function call not a method call)
            !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        */
          this._loadMap.bind(this),

          function () {
            throw new Error('Could not get your position');
          }
        );
      } catch (error) {
        alert(error.message);
      }
    }
  }

  _loadMap(position) {
    try {
      // Creates variables based on the position.coords object
      const { latitude } = position.coords;
      const { longitude } = position.coords;
      let coords = [latitude, longitude];

      // map("map") requires map id in html
      this.#map = L.map('map').setView(coords, this.#mapZoomLevel);

      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(this.#map);

      //Leaflet library method (on) event listener
      this.#map.on('click', this._showform.bind(this));

      this.#workouts.forEach(workout => {
        this._renderMarker(workout);
      });
    } catch (error) {
      throw error;
    }
  }

  _showform(mapE) {
    try {
      this.#mapEvent = mapE;
      form.classList.remove('hidden');
      inputDistance.focus();
    } catch (error) {
      throw new Error('Could not load the form');
    }
  }

  _showSettings() {
    try {
      settings.classList.toggle('hidden');
      this._sortWorkouts();
    } catch (error) {
      throw new Error('Could not load the settings');
    }
  }

  _toggleElevationField() {
    try {
      // Toggle visibility of elevation/cadence fields
      inputElevation
        .closest('.form__row')
        .classList.toggle('form__row--hidden');
      inputCadence.closest('.form__row').classList.toggle('form__row--hidden');
    } catch (error) {
      throw new Error('Could not toggle elevation field');
    }
  }

  _newWorkout(e) {
    try {
      // Validate inputs
      const validInputs = (...inputs) =>
        inputs.every(inp => Number.isFinite(inp));
      const isPositive = (...inputs) => inputs.every(inp => inp > 0);
      e.preventDefault();
      let workout;
      const type = inputType.value;
      const distance = +inputDistance.value;
      const duration = +inputDuration.value;
      const { lat, lng } = this.#mapEvent.latlng;

      if (type === 'running') {
        const cadence = +inputCadence.value;
        if (
          !validInputs(distance, duration, cadence) ||
          !isPositive(distance, duration, cadence)
        )
          return alert('Inputs have to be positive numbers!');
        workout = new Running([lat, lng], distance, duration, cadence);
      }

      if (type === 'cycling') {
        const elevation = +inputElevation.value;
        if (
          !validInputs(distance, duration, elevation) ||
          !isPositive(distance, duration)
        )
          return alert('Inputs have to be positive numbers!');
        workout = new Cycling([lat, lng], distance, duration, elevation);
      }

      this.#workouts.push(workout);
      this._renderMarker(workout);
      this._renderWorkout(workout);

      // Clear input fields
      inputDistance.value =
        inputCadence.value =
        inputDuration.value =
        inputElevation.value =
          ' ';
      form.style.display = 'none';
      form.classList.add('hidden');
      setTimeout(() => (form.style.display = 'grid'), 1000);

      this._setlocalStorage();
    } catch (error) {
      alert('Could not create new workout');
    }
  }

  _renderMarker(workout) {
    try {
      // Render marker on map
      L.marker(workout.coords)
        .addTo(this.#map)
        .bindPopup(
          L.popup({
            maxWidth: 250,
            minWidth: 100,
            autoClose: false,
            closeOnClick: false,
            className: `${workout.type}-popup`,
          })
        )
        .setPopupContent(
          `${workout.type === 'running' ? '🏃‍♂️' : '🚴'} ${workout.description}`
        )
        .openPopup();
    } catch (error) {
      throw new Error('Could not render marker');
    }
  }

  _renderWorkout(workout) {
    try {
      // Render workout in list
      let html = `
      <li class="workout workout--${workout.type}" data-id="${workout.id}">
          <div class="workout__header">
            <h2 class="workout__title">${workout.description}</h2>
            <div class="header-btns"> 
              <button class="workout__edit-btn"><ion-icon name="pencil-outline" class="header-icon"></ion-icon></button>
              <button class="workout__delete-btn"><ion-icon name="trash-outline" class="header-icon"></ion-icon></button>
            </div>
          </div>
          <div class="workout__details">
            <span class="workout__icon">${
              workout.type === 'running' ? '🏃‍♂️' : '🚴'
            }</span>
            <span class="workout__value">${workout.distance}</span>
            <span class="workout__unit">km</span>
          </div>
          <div class="workout__details">
            <span class="workout__icon">⏱</span>
            <span class="workout__value">${workout.duration}</span>
            <span class="workout__unit">min</span>
          </div>`;
      if (workout.type === 'running') {
        html += `
      <div class="workout__details">
            <span class="workout__icon">⚡️</span>
            <span class="workout__value">${workout.pace.toFixed(1)}</span>
            <span class="workout__unit">min/km</span>
          </div>
          <div class="workout__details">
            <span class="workout__icon">🦶🏼</span>
            <span class="workout__value">${workout.cadence}</span>
            <span class="workout__unit">spm</span>
          </div>
        </li>`;
      }
      if (workout.type === 'cycling') {
        html += `
       <div class="workout__details">
            <span class="workout__icon">⚡️</span>
            <span class="workout__value">${workout.speed.toFixed(1)}</span>
            <span class="workout__unit">km/h</span>
          </div>
          <div class="workout__details">
            <span class="workout__icon">⛰</span>
            <span class="workout__value">${workout.elevationGain}</span>
            <span class="workout__unit">m</span>
          </div>
        </li>`;
      }

      // ADDING CUSTOMIZED TEXT TO THE HTML
      // adds the new element as the sibling elemenet of form
      form.insertAdjacentHTML(`afterend`, html);

      // Adding event listener to the delete button after it is created
      deleteWorkout = document.querySelector('.workout__delete-btn');
      deleteWorkout.addEventListener('click', this._deleteWorkout.bind(this));

      editWorkout = document.querySelector('.workout__edit-btn');
      editWorkout.addEventListener('click', this._editWorkout.bind(this));
    } catch (error) {
      throw new Error('Could not render workout');
    }
  }

  _sortWorkouts() {
    try {
      // Sort workouts based on selected option
      let sortInput = document.querySelector('.form__input--sort');
      sortInput.addEventListener('change', () => {
        const sortBy = sortInput.value;
        let sortedWorkouts = this.#workouts.slice();
        if (sortBy === 'date') {
          sortedWorkouts.sort((a, b) => a.date - b.date);
        }
        if (sortBy === 'type') {
          sortedWorkouts.sort((a, b) => a.type.localeCompare(b.type));
        }
        if (sortBy === 'distance') {
          sortedWorkouts.sort((a, b) => a.distance - b.distance);
        }
        if (sortBy === 'duration') {
          sortedWorkouts.sort((a, b) => a.duration - b.duration);
        }
        containerWorkouts
          .querySelectorAll('.workout')
          .forEach(work => work.remove());
        sortedWorkouts.forEach(workout => {
          this._renderWorkout(workout);
        });
      });
    } catch (error) {
      throw new Error('Could not sort workouts');
    }
  }

  _deleteWorkout() {
    try {
      // Delete workout from list and map
      const workoutEl = event.target.closest('.workout');
      if (!workoutEl) return;
      const workout = this.#workouts.find(
        work => work.id === workoutEl.dataset.id
      );
      const index = this.#workouts.indexOf(workout);
      if (index > -1) {
        this.#workouts.splice(index, 1);
      }
      this._setlocalStorage();
      workoutEl.remove();
      this.#map.eachLayer(layer => {
        if (layer instanceof L.Marker) {
          this.#map.removeLayer(layer);
        }
      });
      this.#workouts.forEach(workout => {
        this._renderMarker(workout);
      });
    } catch (error) {
      throw new Error('Could not delete workout');
    }
  }

  _editWorkout() {
    try {
      // Edit workout details
      const workoutEl = event.target.closest('.workout');
      if (!workoutEl) return;
      const workout = this.#workouts.find(
        work => work.id === workoutEl.dataset.id
      );
      inputType.value = workout.type;
      inputDistance.value = workout.distance;
      inputDuration.value = workout.duration;
      if (workout.type === 'running') {
        inputCadence.value = workout.cadence;
        inputElevation.closest('.form__row').classList.add('form__row--hidden');
        inputCadence
          .closest('.form__row')
          .classList.remove('form__row--hidden');
      }
      if (workout.type === 'cycling') {
        inputElevation.value = workout.elevationGain;
        inputCadence.closest('.form__row').classList.add('form__row--hidden');
        inputElevation
          .closest('.form__row')
          .classList.remove('form__row--hidden');
      }
      const index = this.#workouts.indexOf(workout);
      if (index > -1) {
        this.#workouts.splice(index, 1);
      }
      this._setlocalStorage();
      workoutEl.remove();
      form.classList.remove('hidden');
      inputDistance.focus();
      this.#map.eachLayer(layer => {
        if (layer instanceof L.Marker) {
          this.#map.removeLayer(layer);
        }
      });
      this.#workouts.forEach(workout => {
        this._renderMarker(workout);
      });
    } catch (error) {
      throw new Error('Could not edit workout');
    }
  }

  _moveToPopup(e) {
    try {
      // Move map to workout marker
      const workoutEl = e.target.closest('.workout');
      if (!workoutEl) return;
      const workout = this.#workouts.find(
        work => work.id === workoutEl.dataset.id
      );
      this.#map.setView(workout.coords, this.#mapZoomLevel, {
        animate: true,
        pan: {
          duration: 1,
        },
      });
    } catch (error) {
      throw new Error('Could not move to popup');
    }
  }

  _setlocalStorage() {
    try {
      // Save workouts to local storage
      localStorage.setItem('workouts', JSON.stringify(this.#workouts));
    } catch (error) {
      throw new Error('Could not set local storage');
    }
  }

  _getLocalStorage() {
    try {
      // Load workouts from local storage
      const data = JSON.parse(localStorage.getItem('workouts'));
      if (!data) return;
      data.forEach(workout => {
        if (workout.type === 'running') {
          Object.setPrototypeOf(workout, Running.prototype);
          this._renderWorkout(workout);
        }
        if (workout.type === 'cycling') {
          Object.setPrototypeOf(workout, Cycling.prototype);
          this._renderWorkout(workout);
        }
      });
    } catch (error) {
      throw new Error('Could not get local storage');
    }
  }

  reset() {
    try {
      // Reset app and clear local storage
      localStorage.removeItem('workouts');
      location.reload();
    } catch (error) {
      throw new Error('Could not reset app');
    }
  }
}

const myMap = new App();
